import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  const location = useLocation();

  usePageMeta(
    "页面未找到 - 糖豆视频",
    "你访问的页面不存在或已下线，请返回糖豆视频首页继续浏览精选电影、电视剧与综艺内容。",
    "糖豆视频,404,页面未找到",
  );

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-100">
      <Navbar />
      <main className="relative flex w-full flex-1 flex-col items-center justify-center overflow-hidden px-4 py-20 text-center">
        <span className="pointer-events-none absolute top-1/2 -translate-y-1/2 select-none font-heading text-[9rem] font-extrabold leading-none text-background-200 md:text-[15rem]">
          404
        </span>
        <div className="relative z-10 flex flex-col items-center">
          <span className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-50 text-primary-700">
            <i className="ri-compass-discover-line text-2xl" />
          </span>
          <h1 className="mt-5 font-heading text-2xl font-extrabold tracking-tight text-foreground-950 md:text-3xl">
            这条片单好像走丢了
          </h1>
          <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-600">
            你访问的地址 <span className="font-mono text-xs text-primary-700">{location.pathname}</span> 不存在，
            或者对应的内容已从演示片库中移除。
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-2">
            <Link
              to="/"
              className="flex h-10 items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-800 px-5 text-xs font-semibold text-background-50 transition-colors hover:bg-primary-900"
            >
              <i className="ri-home-4-line text-sm" />
              返回首页
            </Link>
            <Link
              to="/category/movie"
              className="flex h-10 items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              浏览电影片库
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}